const setItemToLocalStorage = (name, item) => {
  localStorage.setItem(name, item);
};

const getItemFromLocalStorage = (name) => {
  return localStorage.getItem(name);
};

export {setItemToLocalStorage, getItemFromLocalStorage};
